
































































































import {
  ConferenceDetailRestControllerApi,
  Configuration,
  CvsPaymentInfo,
  DoctorPaymentRestControllerApi,
  GmoCardInfo,
  SettlementInfo,
} from '@/types/api-docs'
import Vue from 'vue'
import Loading from '@/components/Loading.vue'
import CreditCard from '@/components/CreditCard.vue'
import CreditCardForm from '@/components/CreditCardForm.vue'
import GmoPayment, {GetTokenParam} from '@/utils/gmoPayment'

const conferenceDetailApi = new ConferenceDetailRestControllerApi(
    new Configuration({basePath: `${window.location.origin}`})
)

const doctorPaymentApi = new DoctorPaymentRestControllerApi(
    new Configuration({basePath: `${window.location.origin}`})
)

export type DataType = {
  cardNumber: string
  expireMonth: string
  expireYear: string
  name: string
  cvv: string
  shopId: string
  use3ds: boolean
  gmoCardInfo?: GmoCardInfo
  loading: boolean
  convenienceCode: string
  convenienceCodes: any
  customerName: string
  customerNameKana: string
  tel: string
  ruleRequired: any
}

export default Vue.extend({
  name: 'CreditCardPayment',
  components: {CreditCard, Loading, CreditCardForm},
  props: ['id', 'amount', 'user', 'availablePaymentType'],
  data(): DataType {
    return {
      cardNumber: '',
      expireMonth: '',
      expireYear: '',
      name: '',
      cvv: '',
      shopId: '',
      use3ds: false,
      gmoCardInfo: undefined,
      loading: false,
      convenienceCode: '',
      convenienceCodes: [
        {value: "00007", text: "セブンイレブン"},
        {value: "10001", text: "ローソン"},
        {value: "10002", text: "ファミリーマート"},
        {value: "10005", text: "ミニストップ"},
        {value: "10008", text: "セイコーマート"},
      ],
      customerName: '',
      customerNameKana: '',
      tel: '',
      ruleRequired: [
        (v: any) => !!v || '必須項目です',
      ]
    }
  },
  async mounted() {
    await this.fetchConferenceSettlementInfo()
    await this.fetchDefaultCard()
  },
  watch: {
    user() {
      this.customerName = this.user?.lastName + this.user?.firstName
      this.customerNameKana = this.user?.lastNameKana + this.user?.firstNameKana
      this.tel = this.user?.tel
    }
  },
  computed: {
    cvsPaymentAvailable(): boolean {
      return this.availablePaymentType.includes("CONVINI");
    }
  },
  methods: {
    generateGetGmoTokenParam(): GetTokenParam {
      return {
        cardno: this.cardNumber,
        expire: `${this.expireYear}${this.expireMonth}`,
        securitycode: this.cvv,
        holdername: this.name,
      }
    },
    async doSettlement(gmoToken?: string, gmoCardSeq?: number): Promise<string> {
      const settlementInfo: SettlementInfo = {
        amount: this.amount,
        jobCd: "CAPTURE",
      }
      if (gmoToken) {
        settlementInfo.gmoToken = gmoToken
      } else {
        settlementInfo.gmoCardSeq = gmoCardSeq
      }

      return await doctorPaymentApi
          .doCreditCardDoctorPayment(this.id, settlementInfo)
          .then((response) => {
            if (this.use3ds) {
              let data = response.data
              let jsonData = JSON.stringify(data)
              let json = JSON.parse(jsonData)
              return Promise.resolve(json.url)
            } else {
              return Promise.resolve('決済が完了しました')
            }
          })
          .catch(() => {
            return Promise.reject('決済に失敗しました')
          })
    },
    async doGmoPayment(): Promise<void> {
      this.loading = true
      const gmoToken = await GmoPayment.getGmoToken(this.generateGetGmoTokenParam(), this.shopId)
          .then((token) => {
            return token
          })
          .catch((message) => {
            alert(message)
            return null
          })
      if (gmoToken === null) {
        this.loading = false
        return
      }

      if (this.use3ds) {
        await this.doSettlement(gmoToken, undefined)
            .then((message) => {
              window.location.href = message
            })
            .catch((message) => {
              alert(message)
            })
            .finally(() => {
              this.loading = false
            })
      } else {
        await this.doSettlement(gmoToken, undefined)
            .then((message) => {
              alert(message)
              this.$router.go(0)
            })
            .catch((message) => {
              alert(message)
            })
            .finally(() => {
              this.loading = false
            })
      }
    },
    async doGmoPaymentRegisteredCard(gmoCardSeq: number): Promise<void> {
      this.loading = true
      if (this.use3ds) {
        await this.doSettlement(undefined, gmoCardSeq)
            .then((message) => {
              if (this.use3ds) {
                window.location.href = message
              } else {
                alert(message)
                this.$router.go(0)
              }
            })
            .catch((message) => {
              alert(message)
            })
            .finally(() => {
              this.loading = false
            })
      } else {
        await this.doSettlement(undefined, gmoCardSeq)
            .then((message) => {
              alert(message)
              this.$router.go(0)
            })
            .catch((message) => {
              alert(message)
            })
            .finally(() => {
              this.loading = false
            })
      }
    },
    async doCvsDoctorPayment(): Promise<void> {
      let valid = (this.$refs.cvsForm as Vue & { validate: () => boolean }).validate()
      if (!valid) return

      this.loading = true

      const settlementInfo: CvsPaymentInfo = {
        convenienceCode: this.convenienceCode,
        customerName: this.customerName,
        customerNameKana: this.customerNameKana,
        tel: this.tel,
        amount: this.amount
      }

      await doctorPaymentApi
          .doCvsDoctorPayment(this.id, settlementInfo)
          .then(() => {
            alert('コンビニ決済の申し込みが完了しました。支払い方法はメールで送信されます。')
            this.$router.go(0)
          })
          .catch(() => {
            alert('決済に失敗しました')
          })
          .finally(() => {
            this.loading = false
          })
    },
    async fetchConferenceSettlementInfo() {
      const {data} = await conferenceDetailApi.fetchConferenceSettlementInfo()
      this.shopId = data.gmoShopId
      this.use3ds = data.use3ds
    },
    async fetchDefaultCard() {
      const {data} = await doctorPaymentApi.fetchDefaultCard()
      this.gmoCardInfo = data
    },
  },
})
